import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { customEncode, decryptAndValidate } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { MyOrganizationService } from 'libs/data/src/lib/services/my-organization/my-organization.service';

@Component({
  selector: 'piqet-angular-new-organization-membership',
  templateUrl: './new-organization-membership.component.html',
  styleUrls: ['./new-organization-membership.component.scss'],
})
export class NewOrganizationMembershipComponent {
  activatedRoute: any;
  userParams: any;
  modalLabel: any;
  organzationmemberForm!: FormGroup;
  organizationMemberData: any;
  organizationMemberlist: any;
  isReadOnly!: boolean;
  submitted!: boolean;
  lableName: any;
  userInformation: any;
  isPanelOpen = false;
  isLoading = false;
  @Output() saveOrganizationEvent = new EventEmitter<{
    payload: any;
    pathName: any;
  }>();
  @Output() saveAdminOrganizationEvent = new EventEmitter<{
    payload: any;
    pathName: any;
  }>();
  roleListNew: any;
  organizationlist: any;
  selectOrganization: any;
  selectRole: any;
  organizationId: any;
  selectCheckBox = false;
  placeHolder: any;
  isHideField: boolean;
  isShowCusurrencyField!: boolean;
  disableDropdown: any;
  userOrganizationId: any;
  ValidationMessageForOrganizationAndUser: any;
  userId: any;
  addUserObj: any;
  adminOrganizationRoute = 'adminOrganization/details/:id';
  adminManageUserRoute = 'AdminManageUsers/details/:id';
  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private myOrganizationService: MyOrganizationService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.lableName = this.activatedRoute == '' ? 'User' : 'Organization name';
    this.placeHolder =
      this.activatedRoute == this.adminOrganizationRoute ? 'User *' : 'Organization *';
    this.ValidationMessageForOrganizationAndUser =
      this.activatedRoute == this.adminOrganizationRoute
        ? 'User is required'
        : 'Organization is required';
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    if (this.activatedRoute == this.adminOrganizationRoute) {
      this.disableDropdown = false;
    } else if (this.modalLabel == 'Edit organization membership') {
      this.disableDropdown = true;
    }
    this.organizationMemberData =
      this.modal?.modalService?.config?.initialState?.['newOrganizationMemberData'];
    this.organizationId = this.modal?.modalService?.config?.initialState?.['userId'];
    this.userInformation = this.modal?.modalService?.config?.initialState?.['userInfo'];
    this.userOrganizationId = this.organizationMemberData.organizationId;
    this.organizationMemberlist =
      this.organizationMemberData.organizationItems.length > 0
        ? this.organizationMemberData.organizationItems
        : this.organizationMemberData.userItems;
    this.selectCheckBox = this.organizationMemberData.isActive;
    this.isHideField = this.modalLabel == 'Edit organization membership' ? true : false;
    if (
      this.activatedRoute == this.adminOrganizationRoute &&
      this.modalLabel == 'Edit organization membership'
    ) {
      this.isHideField = true;
    } else {
      this.isHideField = false;
    }
    const newRoleListData = this.organizationMemberData.roleItems;
    this.roleListNew = newRoleListData;
    this.roleListFunction();
    this.organizationlist = this.organizationMemberlist;
    this.organizationMemberData.userItems.length > 0
      ? this.getUseDataFun()
      : this.organizatioListFunction();
    this.userParams = this.addUserObj;
  }

  getOrgId() {
    this.route.params.subscribe((res: any) => {
      this.userId = res.id;
    });
  }

  ngOnInit() {
    this.organzationmemberForm = this.formBuilder.group({
      organizationName: [null, Validators.required],
      roleName: [null, [Validators.required]],
    });
    this.setFormData();
    this.getOrgId();
    const userDetail = {
      idLong: this.organizationMemberData?.userId,
    };
    this.selectedValue(userDetail);
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.organizationMemberData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  async getUseDataFun() {
    await this.organizationlist?.map((item: any) => {
      if (item.idStr == this.organizationMemberData.userId) {
        return (this.selectOrganization = item);
      }
    });
  }

  async roleListFunction() {
    await this.roleListNew.map((item: any) => {
      if (item.idStr == this.organizationMemberData.roleId) {
        return (this.selectRole = item);
      }
    });
  }

  setFormData() {
    this.organzationmemberForm.patchValue({
      organizationName: this.selectOrganization,
      roleName: this.selectRole,
    });

    this.addUserObj = {
      opUser: customEncode(btoa('true')),
      oId: customEncode(btoa(this.organizationId)),
    };

    this.userParams = this.addUserObj;
  }

  memberTypeInputSearch(term: string, item: any) {
    return item.roleListNew.toLowerCase().startsWith(term.toLowerCase());
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async refreshUserList() {
    const res = await this.myOrganizationService.getAddEditAdminOrganizationMembershipDetail(
      0,
      this.userId
    );
    this.organizationlist =
      res.data?.organizationItems.length > 0 ? res.data?.organizationItems : res.data?.userItems;
  }

  onSave() {
    this.submitted = true;
    if (
      !this.organzationmemberForm.valid ||
      this.organzationmemberForm.controls['organizationName'].value.name == '-- Select User -- ' ||
      this.organzationmemberForm.controls['organizationName'].value.name ==
        '-- Select Organization -- '
    ) {
      this.submitted = true;
      return;
    }
    let data;
    if (this.activatedRoute == this.adminOrganizationRoute) {
      data = {
        id: this.organizationMemberData.id,
        userId: parseInt(this.organzationmemberForm.controls['organizationName'].value?.idStr) || 0,
        roleId: this.organzationmemberForm.controls['roleName'].value?.idStr || null,
        organizationId: this.organizationId,
        isActive: this.selectCheckBox,
      };
    } else {
      let urlSlash = this.router.url.lastIndexOf('/');
      let userId = this.router.url.slice(urlSlash + 1);
      let id = decryptAndValidate(userId, 'UserId', this.router) ?? 0;
      data = {
        id: this.organizationMemberData.id,
        userId: parseInt(id) || 0,
        roleId: this.organzationmemberForm.controls['roleName'].value?.idStr || null,
        organizationId: this.organzationmemberForm.controls['organizationName'].value?.id,
      };
    }

    if (this.activatedRoute == this.adminOrganizationRoute) {
      this.saveAdminOrganizationEvent.emit({
        payload: data,
        pathName: this.activatedRoute,
      });
    } else {
      this.saveOrganizationEvent.emit({
        payload: data,
        pathName: this.activatedRoute,
      });
    }
    this.modal.close();
  }
  onClose() {
    this.modal.close();
  }

  async selectedValue(eve: any) {
    if (eve.idLong && this.activatedRoute == this.adminOrganizationRoute) {
      this.isLoading = true;
      const response = await this.myOrganizationService.getUserDetailsList(eve.idLong);
      this.userInformation = response.data;
      this.isLoading = false;
    }
    if (eve.id && this.activatedRoute == this.adminManageUserRoute) {
      this.isLoading = true;
      this.getRoleByOrg(eve?.id);
      this.isLoading = false;
    }
  }

  getRoleByOrg(id: any) {
    this.administratorService.getAdminAllRoleList(id, this.organizationId).subscribe((res: any) => {
      if (res.data.length) {
        const modifiedData = res.data.map((item: any) => {
          return {
            ...item,
            name: item.name,
            idStr: item.idStr,
          };
        });
        this.roleListNew = modifiedData;
        this.organzationmemberForm.controls['roleName'].reset();
      }
    });
  }
}
